import type { FC } from "react";
import NotificationCategoryIcon from "src/components/reusable/NotificationCategoryIcon/NotificationCategoryIcon";
import type { InAppNotification } from "../Types/NotificationTypes";
import "../Styles/NotificationListRow.scss";

interface NotificationListRowProps {
  notification: InAppNotification;
  isHighlighted: boolean;
  unreadLabel: string;
  locale: string;
  onClick: (_notification: InAppNotification) => void;
}

const formatNotificationDate = (created: Date): string =>
  `${String(created.getDate()).padStart(2, "0")}-${String(created.getMonth() + 1).padStart(2, "0")}-${created.getFullYear()}`;

const NotificationListRow: FC<NotificationListRowProps> = ({
  notification,
  isHighlighted,
  unreadLabel,
  locale,
  onClick,
}) => {
  const created = new Date(notification.created_at);

  return (
    <button
      type="button"
      data-notification-id={notification.notification_id}
      className={`all-notification-row ${isHighlighted ? "all-notification-row--highlighted" : ""}`}
      onClick={() => onClick(notification)}
    >
      <NotificationCategoryIcon category={notification.category} />
      <span className="all-notification-row__body">
        <span className="all-notification-row__title">{notification.category}</span>
        <span className="all-notification-row__description">
          {notification.content || notification.notification_content}
        </span>
        <span className="all-notification-row__meta">
          {!notification.is_read && (
            <span className="all-notification-row__unread-dot" aria-label={unreadLabel} />
          )}
          {formatNotificationDate(created)}
          {" | "}
          {created.toLocaleTimeString([locale], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })}
        </span>
      </span>
    </button>
  );
};

export default NotificationListRow;
